/**
 * Brand-to-filter-hub slug mapping
 * Used when we have a fridge brand name and need the corresponding filter hub URL slug.
 * Only brands with filter hubs. Electrolux shares filters with Frigidaire.
 */

const BRAND_TO_FILTER_SLUG: Record<string, string> = {
  samsung: 'samsung-refrigerator-water-filters',
  whirlpool: 'whirlpool-refrigerator-water-filters',
  lg: 'lg-refrigerator-water-filters',
  ge: 'ge-refrigerator-water-filters',
  frigidaire: 'frigidaire-refrigerator-water-filters',
  electrolux: 'frigidaire-refrigerator-water-filters', // shares filters with Frigidaire
  kitchenaid: 'kitchenaid-refrigerator-water-filters',
}

/** Normalize brand for lookup: "Kitchen Aid", "Kitchen-Aid" → "kitchenaid" */
function normalizeBrandKey(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[\s\-+]+/g, '')
}

export function getFilterHubSlugForBrand(brandName: string): string | null {
  const key = normalizeBrandKey(brandName)
  return BRAND_TO_FILTER_SLUG[key] ?? null
}
